module.exports = __webpack_public_path__ + "static/media/IMG_6248 - Copy 1.4396c32e.jpg";